<template>
  <div>
    <el-table :data="tableListTwo" style="width: 100%" :max-height="height">
      <el-table-column
        label="编号"
        type="index"
        width="120"
        align="center"
        :index="indexMethod"
      >
      </el-table-column>
      <el-table-column
        label="借伞人"
        prop="empName"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="所属部门"
        prop="department"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="联系电话"
        prop="phone"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="所属地点"
        prop="place"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="借出时间"
        prop="buTime"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="借出数量"
        prop="num"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="已归还数量"
        prop="returnNum"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="剩余未归数量"
        prop=""
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.num - scope.row.returnNum - scope.row.errorNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="归还状态"
        prop="state"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <div
              class="tag tag1"
              style="font-size: 12px"
              v-if="scope.row.state == 1"
            >
              未归还
            </div>
            <div
              class="tag tag2"
              style="font-size: 12px"
              v-if="scope.row.state == 2"
            >
              已归还
            </div>
            <div
              class="tag tag3"
              style="font-size: 12px"
              v-if="scope.row.state == 3"
            >
              异常
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <div
              style="font-size: 16px; margin-right: 10px; color: #4fa27d"
              @click="abnormal(scope.row)"
            >
              异常处理
            </div>
            <div
              style="font-size: 16px; color: #4fa27d"
              @click="returnHistory(scope.row)"
            >
              归还记录
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <MyDialog
      :visible.sync="uploadDialog"
      :type="type"
      :rowList="rowList"
      @changeSubmit="$emit('changeSubmit')"
    />
  </div>
</template>

<script>
import MyDialog from "./borrowAndReturnDialog.vue";
export default {
  name: "borrowAndReturnTableTwo",
  components: {
    MyDialog,
  },
  props: ["tableListTwo", "page"],
  computed: {
    indexMethod() {
      return (index) => (this.page.page - 1) * this.page.pageSize + index + 1;
    },
  },
  data() {
    return {
      height: window.innerHeight - 500,
      uploadDialog: false,
      type: "",
      rowList: {},
    };
  },
  mounted() {},
  methods: {
    // 异常
    abnormal(row) {
      this.rowList = row;
      this.uploadDialog = true;
      this.type = "2";
    },
    // 归还记录
    returnHistory(row) {
      this.rowList = row;
      this.uploadDialog = true;
      this.type = "3";
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
::v-deep {
  .rowTable {
    thead {
      tr {
        th {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
    tbody {
      tr {
        td {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
  }
}
</style>
